<template>
  <div :class="checkWidth() + ' ' + 'container'">
    <CRow>
      <CCol col="12">
        <ChapterSelect
          :funcCountChat="countDefaultChat"
          :funcRoute="funcRoute"
          :content="content"
          :mainContent="show"
          :chapterProgress="chapterProgress"
          :pageCode="pageCode"
          :checkExam="checkExam"
          :loading="loading"
        />
      </CCol>
    </CRow>
  </div>
</template>

<script>
import ChapterSelect from './components/ChapterSelect.vue';
import {mapGetters} from 'vuex';
import '../../../assets/scss/_chineseStyle.scss';

export default {
  components: {ChapterSelect},
  name: 'HP02',
  data() {
    return {
      show: {},
      content: [],
      Intro: [],
      popUpImage: [],
      popUpImageTwo: [],
      type: '',
      CheckFirstPage: 'first',
      code: '',
      CheckWidth: window.innerWidth.toString(),
      defaultChat: false,
      checkAnswer: true,
      courseCode: '',
      chapterProgress: {},
      pageCode: '',
      checkExam: [],
      courseSection: '',
      startTime: '',
      loading: true,
      mockChapterProgress: {
        code: 'HP02-1',
        contentId: '',
        courseId: '',
        lock: false,
        number: 2,
        percent: 100,
        progress: 12,
        template: [],
      },
      v3Data: {},
    };
  },

  computed: {
    ...mapGetters({
      getTemplatev3: 'v3/getTemplates', //เรียก template มาแสดง
      V3GetCourseProgress: 'v3/getCourseProgress', //เรียก progress มาแสดง
      saveScoreAndProgress: 'v3/saveScoreAndProgress',
    }),
  },
  watch: {
    getTemplatev3: {
      handler(val) {
        if (!val) return;
        const template = val.templates[0];

        this.show = val.templates[0];
        this.v3Data = val.templates[0];
        //get Progress
        this.onLoadProgress();

        this.$store.dispatch('v3/v3GetParent', val.codeItem);
      },
    },
    V3GetCourseProgress: function (val) {
      if (!val) return;

      // console.log(val, 'progress');

      // console.log('V3GetCourseProgress', val);
      this.chapterProgress = val.subProgress;
      this.loading = false;
    },
    saveScoreAndProgress: async function (value) {
      console.log('Life cycle...Watch', value);

      if (value.length == 0) {
        return console.log('No data is call');
      }
      //clear is learn
      this.$store.commit('v3/v3IsLearnOff');
      //call on load after get all score
      this.onLoadData();
    },
  },
  created() {},
  mounted() {
    // this.checkIsLearn();
    this.onLoadData();
    // console.log(this.content, 'store content');
    // console.log(this.show, 'for show');
    // console.log(this.loading, 'loading');
  },

  beforeDestroy() {},
  methods: {
    checkIsLearn() {
      //check isLearn
      const isLearn = this.$store.state.v3.isLearn;
      // console.log(isLearn, 'islearnstat');

      if (isLearn) {
        const payload = [
          {
            codeItem: this.$store.state.v3.mainCodeItem,
            courseId: this.$store.state.necessary.learningCourse,
            template: null,
            section: this.$store.state.v3.v3EnrollData.data.section,
            content: null,
            type: null,
            answering: [], // ถ้าหน้าไหนมีแบบฝึกหัดให้เพิ่มส่วนนี้มาด้วย (ต้องอ้างอิงฟอร์มข้ออันเดิม)
            progress: 100,
            score: 0,
            maxScore: 0,
          },
        ];

        if (!payload[0].codeItem) {
          //if payload code item not found
          this.onLoadData();
        } else {
          //if found
          // console.log(payload);

          this.$store.dispatch('v3/saveScoreAndProgress', payload);
        }
      } else {
        //isLearn false
        this.onLoadData();
      }
    },
    v3ManageData() {},
    checkLangClass() {
      if (this.lang == 'CN') {
        return 'fontChinese';
      } else if (this.lang == 'PIN IN') {
        return 'fontPinin';
      } else {
        return '';
      }
    },
    checkWidth() {
      if (this.CheckWidth > 500) {
        return 'container-chinese-card';
      } else if (this.CheckWidth <= 500) {
        return 'container-chinese-card-mobile';
      }
    },
    onLoadData() {
      //check done
      //loading course
      // this.$store.commit('courses/setCourseQuizPermissionZero');
      // this.courseCode = this.$store.getters['necessary/getLerningCourse']._id;
      // this.pageCode = `HP02-` + this.$route.params.id;
      // console.log(this.courseCode, this.pageCode);
      //body
      //{code:'12313',templateCode = `params.id`}
      // let body = {};
      // body.code = this.courseCode;
      // body.templateCode = `HP02-` + this.$route.params.id;
      // this.$store.dispatch('template/fetchContent', body);
      ////SetTemplateContent []
      ////SetTemplateQuestion []
      //content.nav[0].

      this.startTime = this.$helpers.getDateFormat();

      //loadfor non display route
      const contentId = `HP02-${this.$route.params.id}`;
      this.$store.dispatch('v3/fetchTemplateByCode', contentId);
      //

      // this.show = this.$store.state.v3.templates.templates[0];
      // this.loading = false;
    },
    onLoadProgress() {
      // เรียก progress มาแสดง
      const payload = {
        codeItem: this.$store.state.v3.templates.templates[0].codeTemplate,
        courseId: this.$store.state.necessary.learningCourse,
      };

      // console.log(payload, 'courseprogress');

      this.$store.dispatch('v3/fetchCourseProgress', payload); // เรียก progress มาแสดงจาก backend --> ไปที่ Watch เพื่อเช็คข้อมูล
    },
    funcRoute(tempId) {
      // console.log(tempId, 'temp');
      // let v3Url = `v3/` + tempId;
      // let body = this.$helpers.setChineseUrl(v3Url);
      // this.$router.push(body);
      // console.log('funct route start');

      this.$store.commit('v3/setFetchDataBy', 'code'); // call mutation from vuex storage

      //setOn is learn
      this.$store.commit('v3/v3IsLearnOn');
      //stamp main code item

      this.$store.commit('v3/stampMainCodeItem', tempId); // บันทึกข้อมูลตัวแม่ของชุดข้อมูล

      const pathFormat = tempId.split('-');
      this.$router.push(`/v3/${pathFormat[0]}/${pathFormat[1]}`);
    },
    closeModal() {
      this.openModalConver = !this.openModalConver;
    },
    countDefaultChat() {
      return (this.defaultChat = true);
    },
  },
};
</script>

<style>
.displayNone {
  display: None;
}

.displayBlock {
  display: block;
}
</style>
